import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import { Icon, Modal } from 'antd';
import Icon2 from 'kts-platform-frame/display/components/Icon';
const css = require('./index.scss');
/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** iframe */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIHelp extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            nextStep: false,
        };
    }

    render() {
        const { nextStep } = this.state;
        return (
            <Modal
                className={css.help}
                title={nextStep ? '菜单栏模式' : '添加常用'}
                width={500}
                visible={this.modulesState.helpVisible}
                footer={null}
                onCancel={this.close}
            >
                {nextStep ?
                    <div className={css.next}>
                        <div className={css.show}>
                            <div>
                                <img src={require('./Icon/help2.png')} />
                                <div className={css.message}>极简应用模式，应用一触即达。</div>
                            </div>
                            <div>
                                <img src={require('./Icon/help3.png')} />
                                <div className={css.message}>传统菜单模式，应用分类清晰。</div>
                            </div>
                        </div>
                        <div className={css.btnBox}>
                            <div className={css.btn} onClick={this.close}>开始了解</div>
                        </div>
                    </div>
                    :
                    <div className={css.popular}>
                        <img src={require('./Icon/help1.png')} />
                        <div className={css.message}>鼠标悬浮在应用上，点击<span className={css.ding}><Icon2 src={require('./Icon/ding2.svg')} /></span>图标可将应用添加为常用到左侧菜单栏。</div>
                        <div className={css.btn} onClick={this.clickNext}>下一步</div>
                    </div>
                }
            </Modal>
        );
    }
    private close = (e)=>{
        e.stopPropagation();
        this.modulesState.helpVisible = false;
        this.setModulesState();
    }
    private clickNext = (e)=>{
        e.stopPropagation();
        this.setState({
            nextStep: true,
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench2/UI.MenuNew/UI.Help.tsx